import { ItemIds, LAYOUT_LIST, TEXT, SCROLLABLE_CONTAINER } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { ItemDefinition } from '~/training/sequence/templates/items/Item';
import { getEditorState } from '~/shell/Store';

export const Images6: Translator = sequence => {
  const editorMode = getEditorState().editorMode;
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card': {
        const extraItemList = [];

        extraItemList.push({
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            value: item.title,
            variant: 'heading3',
            icon: item.icon
          },
          items: []
        });

        if (item.body) {
          if (editorMode) {
            extraItemList.push({
              id: `${item.id}_body`,
              type: TEXT,
              values: {
                value: item.body.split('\r\n').join('<br>')
              },
              items: []
            });
          } else {
            item.body.split('\r\n').forEach((text, index) => {
              if (text) {
                extraItemList.push({
                  id: `${index}.body`,
                  type: TEXT,
                  values: {
                    value: text
                  },
                  items: []
                });
              }
            });
          }
        }

        const card = CardHelper(
          { ...item, title: '', body: '' } as ItemOfType<'Card'>,
          {
            width: { _: '300px', md: '368px' },
            height: 'auto',
            align: 'left',
            padding: '0px',
            extraItems: extraItemList as ItemDefinition<ItemIds>[],
            isImageDecorative: true,
            type: editorMode ? 'div' : 'li'
          }
        );

        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center',
            type: editorMode ? 'div' : 'ul'
          },
          items: editorMode
            ? [
                {
                  id: `${item.id}_wrapper`,
                  type: SCROLLABLE_CONTAINER,
                  values: {
                    height: '80vh',
                    overflow: 'auto',
                    center: true
                  },
                  items: [card]
                }
              ]
            : [card]
        };
      }
      default:
        return null;
    }
  });
};
